export default __webpack_public_path__ + "static/media/isn.2fdbbadf.png";